import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const profileCardContainer = style({
  color: themeVars.container.foreground.primary,
  overflow: 'hidden',
});

export const coverImage = style([
  responsiveStyle({
    mobile: {
      aspectRatio: '11 / 3',
    },
    tablet: {
      aspectRatio: '20 / 3',
    },
    desktop: {
      aspectRatio: '21 / 5',
    },
  }),
]);

export const editableImage = style({
  transition: 'filter 0.2s',

  ':hover': {
    filter: 'brightness(0.95)',
  },
});

export const bodyContainer = style({
  display: 'flex',
  flexDirection: 'column',

  ...responsiveStyle({
    mobile: {
      padding: `${space.s10}px ${space.s16}px ${space.s16}px`,
      gap: space.s8,
    },
    desktop: {
      padding: `${space.s28}px ${space.s16}px`,
      gap: space.s32,
    },
  }),
});
